const KEY = "sx_cart";

export const getCart = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

export const setCart = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event("sx-cart"));
};

export const addToCart = (item) => {
  const cart = getCart();
  if (cart.find((i) => i.id === item.id)) return false;
  setCart([...cart, { id: item.id, title: item.title, price: item.price, image_url: item.image_url }]);
  return true;
};

export const removeFromCart = (id) => setCart(getCart().filter((i) => i.id !== id));

export const clearCart = () => setCart([]);
